export default "__VITE_ASSET__SbuTMsYg__"